import { FC } from "react";

interface LocaleViewProps {
  audience: string;
  children: React.ReactNode;
  locales: string[];
}

const LocaleView: FC<LocaleViewProps> = ({ audience, children, locales }) => {
  return locales.includes(audience) ? <>{children}</> : null;
};

export default LocaleView;
